export default __webpack_public_path__ + "static/media/hra_access.913d2c28.svg";